import type {XlsxRow} from "./types.ts";
import {useState} from "preact/hooks";
import {DateTime} from "luxon";
import {throwIfInvalid} from "./utils.ts";

export function GetForDate({historic}: { historic: XlsxRow[] }) {
    const [refDate, setRefDate] = useState(DateTime.now());
    const minDate = historic[0]?.date;
    const maxDate = historic[historic.length - 1]?.date;

    function updateDate(event: Event) {
        setRefDate(throwIfInvalid(DateTime.fromISO((event.target as HTMLInputElement).value)));
    }

    return (
        <div class="text-center pt-5 col col-12 col-sm-6"
             id="datepick">
            <h1>Valor de la UI en la fecha</h1>
            <input
                min={minDate?.toISODate()}
                max={maxDate?.toISODate()}
                value={refDate?.toISODate()}
                onChange={updateDate}
                type="date" class="form-control"/>
            <h3>{historic.find(r => r.date.toISODate() === refDate.toISODate())?.ui} Pesos
                Uruguayos</h3>
        </div>
    )
}